import { render, staticRenderFns } from "./point_vip.vue?vue&type=template&id=493203e6&scoped=true&"
import script from "./point_vip.vue?vue&type=script&lang=js&"
export * from "./point_vip.vue?vue&type=script&lang=js&"
import style0 from "./point_vip.vue?vue&type=style&index=0&id=493203e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493203e6",
  null
  
)

export default component.exports